import React from 'react'
import { ORDER_STATES } from '../../assets/data/arrays'
import { TagIcon } from '@heroicons/react/24/outline'
import { Input, Select } from '../ui'
import { FormField } from '../ui/Form'

interface StatusSelectorProps {
  value: string
  onChange: (value: string) => void
  mode: 'view' | 'edit' | 'create'
  userRoleId: number
  recogeEnBodega: boolean
  currentStatus?: string
  paymentMethod?: string
  errors?: { [key: string]: string }
  disabled?: boolean
}

const StatusSelector: React.FC<StatusSelectorProps> = ({
  value,
  onChange,
  mode,
  errors,
  disabled = false
}) => {
  // Lista completa siempre: el select está bloqueado y el estado lo define el pago / pedido.
  const availableStates = [...ORDER_STATES]

  const statusToEnsure = (value || '').toString().trim()
  if (
    statusToEnsure &&
    !availableStates.some((estado) => estado.value === statusToEnsure)
  ) {
    const fromCatalog = ORDER_STATES.find((estado) => estado.value === statusToEnsure)
    availableStates.push(
      fromCatalog || {
        value: statusToEnsure,
        label: statusToEnsure,
        color: 'bg-gray-100 text-gray-800'
      }
    )
  }

  const sortedStates = [...availableStates].sort((a, b) =>
    a.label.localeCompare(b.label, 'es', { sensitivity: 'base' })
  )

  const selectOptions = [
    { value: '', label: 'Seleccione' },
    ...sortedStates.map((estado) => ({
      value: estado.value,
      label: estado.label
    }))
  ]

  return (
    <FormField
      label="Estado"
      required
      error={errors?.status}
      icon={TagIcon}
      labelClassName="flex items-center gap-1"
    >
      {mode === 'view' ? (
        <Input
          type="text"
          value={value || ''}
          readOnly
          mode="view"
        />
      ) : (
        <Select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          options={selectOptions}
          placeholder="Seleccione"
          error={!!errors?.status}
          errorMessage={errors?.status}
          mode={mode}
        />
      )}
    </FormField>
  )
}

export default StatusSelector
